<table>
  <tr>
    <td>
      <button type="button" (click)="viewToken()" label="View Xero OAuth Tokens" pButton></button>
    </td>
    <td>
      <button type="button" (click)="refreshToken()" label="Refresh Xero Tokens" pButton></button>
    </td>
  </tr>
</table>

<div *ngIf="showXeroTokenRecord">
  <div *ngIf="xeroTokenRecord == null">
    <h2>OAuth Token not found</h2>
    <button type="button" (click)="refreshToken()" label="Fetch a new token" pButton></button>
  </div>

  <div *ngIf="xeroTokenRecord != null">
    <h2>Token Expiry Date</h2>
    <pre>{{ xeroTokenRecord.expiryDate | date : 'dd MMM YYYY HH:mm' }}</pre>
    <h2>Tenant ID</h2>
    <pre>{{ xeroTokenRecord.tenantId }}</pre>
    <h2>Scope Claims</h2>
    <ul>
      <li *ngFor="let scopeClaim of xeroTokenRecord.claims">{{ scopeClaim.claimValue }}</li>
    </ul>
  </div>
</div>
